import React from 'react';

interface IUserIconProps {
  width?: string;
  height?: string;
}

export const UserIcon = (props: IUserIconProps) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path 
      fill="currentColor"
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M10.0001 1.75487C7.40637 1.75487 5.30512 3.85737 5.30512 6.44987C5.30512 9.04237 7.40637 11.1449 10.0001 11.1449C12.5926 11.1449 14.6951 9.04237 14.6951 6.44987C14.6951 3.85737 12.5926 1.75487 10.0001 1.75487V1.75487ZM18.5364 19.2549H1.46387V17.5136C1.46387 15.1749 3.36012 13.2799 5.69887 13.2799H14.3014C16.6401 13.2799 18.5364 15.1749 18.5364 17.5136V19.2549Z" 
    />
  </svg>
);
